import config from "../config";

/**
 * Initiates a payment by creating a Stripe Checkout Session.
 *
 * @param {string|number} amountInEuros - The amount in euros.
 * @param {string} depositId - The deposit ID.
 * @returns {Promise<string>} A promise that resolves to the Stripe Checkout Session ID.
 * @throws Will throw an error if the session creation fails.
 */

export async function initiatePayment(amountInEuros, depositId) {
  // Convertir le montant en centimes
  const amount = parseInt(amountInEuros, 10);
    
  // URL de votre fonction Firebase déployée
  const endpointURL = `${config.API_BASE_URL}/createCheckoutSession`;
  
  try {
    const response = await fetch(endpointURL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount, depositId })
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error("Erreur lors de la création de la session: " + JSON.stringify(data));
    }
    
    return data.id;
    
  } catch (error) {
    console.error("Erreur dans initiatePayment:", error);
    throw error;
  }
}
